<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">{{ 'MENU.SIZES.EDIT_SIZE' | translate }}</div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="dish">
      <div class="dish-data">
        <mat-form-field class="dish-name" appearance="fill">
          <mat-label>{{ 'MENU.SIZES.SIZE_NAME' | translate }}</mat-label>
          <input matInput type="text" formControlName="name" [class.isDifferent]="isSizeNameDifferent()"
                 (input)="updateChangesInformationMessage()">
          <mat-icon *ngIf="isSizeNameDifferent()" matSuffix mat-icon-button aria-label="Clear"
                    matTooltip="{{data.originalSize?.name}}" (click)="clearSizeName()">restore
          </mat-icon>
        </mat-form-field>

        <div *ngIf="data.organization.additionalLanguages">
          <mat-form-field class="dish-name" appearance="fill"
                          *ngFor="let lang of data.organization.additionalLanguages">
            <mat-label>{{'MENU.SIZES.SIZE_NAME' | translate}} {{lang}}</mat-label>
            <input matInput formControlName="{{getFormLangName(lang)}}"
                   [class.isDifferent]="isSizeNameLanguageDifferent(lang)"
                   (input)="updateChangesInformationMessage()">
            <mat-icon *ngIf="isSizeNameLanguageDifferent(lang)" matSuffix mat-icon-button aria-label="Clear"
                      matTooltip="{{data.originalSize.nameTranslations[lang]?? 'undefined'}}" (click)="clearSizeTranslateName(lang)">
              restore
            </mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>
    <app-changes-for-menus
      [changesInformationMessage]="changesInformationMessage"
      [menuSections]="this.data.menuSections"
      [currentMenuSectionId]="this.data.menuSectionId"
      (menusSelected)="onMenuSelectedChanges($event)">
    </app-changes-for-menus>
    <div class="form-bottom">
      <button
        class="submit"
        mat-button
        [disabled]="form.invalid || !formTouched"
      >{{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </form>
</div>
